import { RouteConfig } from 'vue-router';

import { multiGuard } from '../Middleware/MultiGuard';

import { permissionPageExam, permissionExams } from '../Middleware/permission/PageExam';
import { permissionFeature } from '../Middleware/permission/Feature';

export const NAME_ROUTES_EXAM = {
  LIST: 'Exams',
  SHOW: 'Exam',
  ExamViewer: 'ExamViewer'
};

export const Exam: Array<RouteConfig> = [
  {
    path: '/vestibular',
    component: () => import('@/layouts/Default/index.vue'),
    beforeEnter: permissionExams,
    children: [
      {
        path: '',
        name: NAME_ROUTES_EXAM.LIST,
        component: () => import(/* webpackChunkName: "exam" */ '@/pages/Exams/index.vue'),
        meta: { title: 'Vestibulares' }
      }
    ]
  },
  {
    path: '/vestibular',
    component: () => import('@/layouts/Sidebar/index.vue'),
    beforeEnter: permissionExams,
    children: [
      {
        path: ':book/:idExam',
        name: NAME_ROUTES_EXAM.SHOW,
        component: () => import(/* webpackChunkName: "exam-show" */ '@/pages/Exams/pages/Exam/index.vue'),
        meta: { title: 'Vestibular Questões' },
        beforeEnter: multiGuard([
          permissionFeature,
          permissionPageExam
        ])
      },
      {
        path: 'pdf/:idExam/:idFile/:slug',
        name: NAME_ROUTES_EXAM.ExamViewer,
        component: () => import(
          /* webpackChunkName: "exam-show-pdf" */ '@/pages/Exams/pages/ExamViewer/index.vue'
        ),
        meta: { title: 'Visualizador Vestibular' },
        beforeEnter: multiGuard([permissionFeature, permissionPageExam])
      }
    ]
  }
];
